@if (isIiifEnabled$ | async) {
  <p class="full-text-op">{{'iiifviewer.fullscreen.notice' | translate}}</p>
  @if (!isViewerAvailable) {
    <p id="viewer-message">{{viewerMessage}}</p>
  }
@if (isViewerAvailable || (iframeViewerUrl | async) !== null) {
  <iframe title="Mirador Viewer" allowtransparency="true" [src]="iframeViewerUrl | async | dsSafeUrl" id="mirador-viewer"></iframe>
  }
}

